module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Db-Fb-Gd-Hc-Ia.89fdef1a.png";